import axios from 'axios'
import { reLoadWeb } from '@/utils'
import Login from '@/components/login'

// 构建请求$HTTP, 所有的API都会走到这里
const baseURL = import.meta.env.VITE_BASE_URL
const timeout = 60000
const $http = axios.create({
  baseURL,
  timeout,
  responseType: 'json',
  withCredentials: true, // 跨域时同步发送cookie
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

// 请求拦截器
$http.interceptors.request.use(
  async (config) => {
    // 检验是否登录，未登录要求登录
    // await Login.value.requestInterceptor()
    //增加token
    let token = Login.value.getToken()
    if (token) { config.headers['token'] = token }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
$http.interceptors.response.use(
  async (response) => {
    // 数据 - 没有数据的时候
    const data = response.data
    if ([401, 403].includes(data.code || data.status)) {
      // 重新请求token和加载页面
      await Login.value.fetchToken(data)
      reLoadWeb()
      return Promise.reject(data.resultMsg)
    }
    return response
  },
  async (error) => {
    const response = error?.response
    if ([401, 403].includes(response?.status)) {
      return new Promise(async (resolve, reject) => {
        // 重新请求token和加载页面
        await Login.value.fetchToken()
        reLoadWeb()
        resolve(null) // 更换token完成后，重新触发当前请求，拿到新的结果并执行reslove
      })
    }
    return Promise.resolve(error)
  }
)
export { $http, baseURL }
